import { ComponentProps } from 'react';
import AddItemModal from '../../components/AddItemModal';
import DeleteConfirmModal from '../../components/DeleteConfirmModal';
import ItemDetailsModal from '../../components/ItemDetailsModal';
import { ItemWorkflows } from './useItemWorkflows';

export function ItemWorkflowModals({
  workflow,
  readOnly = false,
  enqueue,
}: {
  enqueue?: ComponentProps<typeof AddItemModal>['enqueue'];
  workflow: ItemWorkflows;
  readOnly?: boolean;
}) {
  return (
    <>
      <AddItemModal {...workflow.modalProps.addItem} enqueue={enqueue} />
      <DeleteConfirmModal {...workflow.modalProps.deleteConfirmation} />
      <ItemDetailsModal
        {...workflow.modalProps.itemDetails}
        readOnly={workflow.modalProps.itemDetails.readOnly ?? readOnly}
      />
    </>
  );
}
